import React from "react";
import NavBarBrand from "./NavBarBrand";
import NavBarButtons from "./NavBarButtons";
import NavBarTabs from "./NavBarTabs";
import SeasonalLights from "../../seasonal/SeasonalLights";

const NavigationBar = () => {
    return (
        <div className="nav-bar__container">
            <nav className="nav-bar">
                <NavBarBrand />
                <NavBarTabs />
                <NavBarButtons />
                <SeasonalLights />
            </nav>
        </div>
    );
};

export default NavigationBar;
